import type { FaireProductEntity } from "../../entity_types/product";

export const p_h65ycjtpe4: FaireProductEntity = {
  token: "p_h65ycjtpe4",
  type: "product",
  name: "Lays Magic Masala - INDIA (20 COUNT)",
  brandToken: "b_pdahr8yenn",
  brandName: "Exotic Snacks Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/4ba31401d8d74c5e17415554a7b729ce5bf188eec8017c95c8d94d8cc001f4b3.jpeg",
  galleryImageUrls: [],
  priceDollars: 48.5,
  description:
    "Lays Magic Masala - INDIA from Flavor Distribution, the first to distribute exotic snacks in America. This 20 count pack offers a new taste experience. Our prices are firm as we guarantee product freshness. We offer warehouse pickup and shipping all over America. Enjoy a burst of flavors with every bite.",
  tags: [],
  msrpDollars: 97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:36.332Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
